"use client";

import React from "react";
import HomeChatBubble from "./HomeChatBubble";

export default function HomeChatMessages({ interactions, isSending }) {
  return (
    <>
      {interactions.map((m, i) => (
        <HomeChatBubble
          key={m.id}
          role={m.role}
          message={m.message}
          isSending={isSending && i === interactions.length - 1}
        />
      ))}
    </>
  );
}
